import Button from '@jbhi-fi/lanyard-ui/components/Button';
import React, { useEffect, useState } from 'react';
import { useTracking, trackingContext } from '@jbhi-fi/components/src/Tracking';
import { DeliveryLocation } from '../localisation/utils/types';
import { styles } from './LocationSearch.css';

export type LocationSearchResultsProps = {
  data: Array<DeliveryLocation>;
  onSelect: (result: DeliveryLocation) => void;
  setInputValue: (value: string) => void;
  setData: (value: unknown[]) => void;
};

const LocationSearchResults = ({ data, onSelect, setInputValue, setData }: LocationSearchResultsProps) => {
  const [selected, setSelected] = useState(0);
  const [enterPressed, setEnterPressed] = useState(false);
  const { tracker } = useTracking({
    context: trackingContext.localisation,
    category: 'localisation',
    group: 'location-search-results',
  });
  const itemClickHandler = (item: DeliveryLocation) => {
    onSelect(item);
    setInputValue(item.displayName);
    setData([]);
  };

  const keyHandler = ({ key }: any) => {
    if (data.length) {
      if (key === 'ArrowDown') {
        setSelected(prevState => (prevState < data.length - 1 ? prevState + 1 : prevState));
      }
      if (key === 'ArrowUp') {
        setSelected(prevState => (prevState > 0 ? prevState - 1 : prevState));
      }
      if (key === 'Enter') {
        setEnterPressed(true);
        tracker.trackCustomEvent({
          label: 'location-selected',
          event: `keyPress-${key}`,
          eventCategory: 'keypress',
          value: data[selected].postcode,
        });
      }
    }
  };

  useEffect(() => {
    enterPressed && itemClickHandler(data[selected]);
  }, [enterPressed]);

  useEffect(() => {
    window.addEventListener('keydown', keyHandler);

    return () => {
      window.removeEventListener('keydown', keyHandler);
    };
  }, []);

  return (
    <ul className={styles.suggestions}>
      {data.map((item, i) => (
        <li key={`${item.suburb}-${i}`} className={`${styles.suggestionItem} ${selected === i ? 'active' : ''}`}>
          <Button
            classes={styles.suggestionItemButton}
            type="link"
            onClick={e => {
              e.preventDefault();
              itemClickHandler(item);
            }}
          >
            {item.suburb} {item.state} {item.postcode}
          </Button>
        </li>
      ))}
    </ul>
  );
};

export default LocationSearchResults;
